import type { FaireProductEntity } from "../../entity_types/product";

export const p_dz44i1aiof: FaireProductEntity = {
  token: "p_dz44i1aiof",
  type: "product",
  name: "Cozy Cabin \u2013 Scented Wax Melts 8-Pack by ACG",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/cea50c0e33de3646200d028f36b43ed7b7584a16b574e4d70131a44cb7e0cd17.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
